import z from 'zod';
/**
 * Outcome of one ayant-droit statut write.
 *
 * `ignored` exists because the billetterie answers 200 to a statut change and returns the
 * resource with its OLD statut — the write is silently dropped on their side (verified on
 * preprod 2026-08-07, CSE 134 / ayant-droit 94). We compare what came back to what we asked
 * for so the UI can report what really happened instead of a false success.
 */
export const AyantDroitBulkOutcome = {
    updated: 'updated',
    ignored: 'ignored',
    failed: 'failed',
};
/** Keeps one request short enough to stay well inside HTTP timeouts; the client chunks. */
export const AYANTS_DROITS_BULK_MAX_IDS = 50;
export const bulkSetAyantsDroitsValidationSchema = z.object({
    ids: z.array(z.number().int().positive()).min(1).max(AYANTS_DROITS_BULK_MAX_IDS),
    validated: z.boolean(),
});
